import React, { Component } from 'react';
import {
    Box, List, ListItem, ListItemText,
    withStyles
} from '@material-ui/core';
import { Business, Assignment, Receipt } from '@material-ui/icons';
import Swal from 'sweetalert2';
import BreadcrumbLayout from "../../shared/components/common/breadcrumbLayout";
import { WorkshopService } from './service';
import { ClientQuoteDetailsApi } from '../../client/clientQuoteDetails/service/clientQuoteDetailsApi';
import { parseQuoteDetailsResponse } from '../../shared/utils/quoteDetailsMapper';
import CardSection from "../../shared/components/common/cardSection";
import ClienteSection from "../../shared/components/details/detailsClienteSection";
import EstimativaSection from "../../shared/components/details/detailsEstimativaSection";
import OrcamentoSection from "../../shared/components/details/detailsOrcamentoSection";
import ServiceFilesSection from "../../shared/components/details/serviceFilesSection";
import NotasFileSection from "../../shared/components/details/notasFileSection";
import QuoteBudgetFileSection from "../../shared/components/details/quoteBudgetFileSection";
import QuoteLaudoFileSection from '../../shared/components/details/quoteLaudoFileSection';
import QuoteNfFileSection from '../../shared/components/details/quoteNfFileSection';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";

const styles = theme => ({
    root: {
        backgroundColor: '#FFFFFF',
        minHeight: '100vh',
        padding: '1rem'
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200
    },
    errorContainer: {
        padding: theme.spacing(2),
        textAlign: 'center'
    },
    actionButtons: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(2)
    },
    recebimentoButton: {
        fontWeight: 'bold'
    }
});

class WorkshopDetailsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cliente: null,
            estimativa: null,
            orcamento: null,
            sections: {
                cliente: true,
                estimativa: true,
                orcamento: true,
                manutencao: true,
                serviceFiles: true
            },
            serviceFiles: [],
            rotasimplesempresa: null,
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.initDetalhes();
    }

    componentWillUnmount() {
        this.cleanupDetalhes();
    }

    getQuotationIdFromUrl = () => {
        const search = window.location.search || '';
        const idFromSearch = new URLSearchParams(search).get('id');
        if (idFromSearch) return idFromSearch;

        const hash = window.location.hash || '';
        if (hash.includes('?')) {
            const queryString = hash.split('?')[1];
            return new URLSearchParams(queryString).get('id');
        }

        return null;
    };

    async initDetalhes() {
        try {
            const quotationId = this.getQuotationIdFromUrl();
            if (quotationId) {
                const response = await ClientQuoteDetailsApi.getQuoteDetails(quotationId);
                const data = parseQuoteDetailsResponse(response.data);
                this.setState({
                    workshopId: quotationId,
                    cliente: data.cliente,
                    estimativa: data.estimativa,
                    orcamento: data.orcamento,
                    serviceFiles: data.serviceFiles,
                    rotasimplesempresa: data.rotasimplesempresa,
                    loading: false
                });
            } else {
                this.setState({
                    error: 'ID n\u00e3o encontrado na URL',
                    loading: false
                });
            }
        } catch (error) {
            console.error('Erro ao carregar detalhes do workshop:', error);
            this.setState({
                error: 'Erro ao carregar detalhes do workshop',
                loading: false
            });
        }
    }

    cleanupDetalhes() {
        this.setState({
            cliente: null,
            estimativa: null,
            orcamento: null,
            serviceFiles: [],
            rotasimplesempresa: null,
            loading: true,
            error: null
        });
    }

    toggleSection = (section) => {
        this.setState(prevState => ({
            sections: {
                ...prevState.sections,
                [section]: !prevState.sections[section]
            }
        }));
    };

    formatarData = (data) => {
        return WorkshopService.formatarData(data);
    };

    formatarMoeda = (valor) => {
        return WorkshopService.formatarMoeda(valor);
    };

    receberEquipamento = async () => {
        const id = this.getQuotationIdFromUrl();
        if (!id) {
            Swal.fire('Erro', 'ID da estimativa n\u00e3o encontrado.', 'error');
            return;
        }

        const result = await Swal.fire({
            title: "Confirmar recebimento?",
            text: 'Isso sinaliza o cliente do recebimento e indica que o equipamento ser\u00e1 analisado.',
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sim, confirmar",
            cancelButtonText: "Cancelar"
        });

        if (!result.isConfirmed) return;

        try {
            await WorkshopService.receiveEquipment(id);

            this.setState(prevState => ({
                estimativa: {
                    ...prevState.estimativa,
                    status: 'equipamento em analise'
                }
            }));

            Swal.fire('Sucesso', 'Equipamento recebido. Status atualizado para \'equipamento em an\u00e1lise\'.', 'success');

        } catch (err) {
            console.error('Erro ao receber equipamento:', err);
            Swal.fire('Erro', 'N\u00e3o foi poss\u00edvel atualizar a estimativa.', 'error');
        }
    };

    fazerApontamento = async () => {
        const id = this.getQuotationIdFromUrl();
        if (!id) {
            Swal.fire('Erro', 'ID da estimativa n\u00e3o encontrado.', 'error');
            return;
        }

        const result = await Swal.fire({
            title: 'Registrar Apontamentos',
            input: 'textarea',
            inputLabel: 'Apontamentos',
            inputPlaceholder: 'Digite os apontamentos t\u00e9cnicos sobre a an\u00e1lise do equipamento.',
            inputAttributes: {
                'aria-label': 'Apontamentos'
            },
            inputValidator: (value) => {
                if (!value || !value.trim()) {
                    return 'Apontamentos s\u00e3o obrigat\u00f3rios.';
                }
            },
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        try {
            await WorkshopService.submitApontamentos(id, result.value);

            Swal.fire('Sucesso', 'Apontamentos registrados com sucesso.', 'success');

            // Recarregar dados da cotacao
            this.initDetalhes();

        } catch (err) {
            console.error('Erro ao registrar apontamentos:', err);
            Swal.fire('Erro', 'N\u00e3o foi poss\u00edvel registrar os apontamentos.', 'error');
        }
    };

    handleCompleteMaintenance = async () => {
        const id = this.getQuotationIdFromUrl();
        if (!id) {
            Swal.fire('Erro', 'ID da estimativa n\u00e3o encontrado.', 'error');
            return;
        }

        const result = await Swal.fire({
            title: 'Concluir Manuten\u00e7\u00e3o?',
            text: 'Deseja sinalizar que a manuten\u00e7\u00e3o foi realizada e aguardar a inspe\u00e7\u00e3o e laudo?',
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sim, concluir",
            cancelButtonText: "Cancelar"
        });

        if (!result.isConfirmed) return;

        try {
            await ClientQuoteDetailsApi.completeMaintenance(id);
            Swal.fire('Sucesso', 'Manuten\u00e7\u00e3o conclu\u00edda. Status atualizado para \'aguardando inspe\u00e7\u00e3o e laudo\'.', 'success').then(() => {
                this.initDetalhes();
            });
        } catch (err) {
            console.error('Erro ao concluir manutencao:', err);
            Swal.fire('Erro', 'N\u00e3o foi poss\u00edvel concluir a manuten\u00e7\u00e3o.', 'error');
        }
    };

    handleApproveMaintenance = async () => {
        const id = this.getQuotationIdFromUrl();
        if (!id) {
            Swal.fire('Erro', 'ID da estimativa n\u00e3o encontrado.', 'error');
            return;
        }

        const result = await Swal.fire({
            title: 'Aprovar para Manuten\u00e7\u00e3o?',
            text: 'Deseja avan\u00e7ar este item para "Aprovado para manuten\u00e7\u00e3o"?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, aprovar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        try {
            await ClientQuoteDetailsApi.updateQuotationStatus(id, 'aprovado para manutencao');
            Swal.fire('Sucesso', 'Status atualizado para "Aprovado para manuten\u00e7\u00e3o".', 'success').then(() => {
                this.initDetalhes();
            });
        } catch (err) {
            console.error('Erro ao aprovar para manutencao:', err);
            Swal.fire('Erro', 'N\u00e3o foi poss\u00edvel atualizar o status.', 'error');
        }
    };

    handleMarkAsSent = async () => {
        const id = this.getQuotationIdFromUrl();
        if (!id) {
            Swal.fire('Erro', 'ID da estimativa n\u00e3o encontrado.', 'error');
            return;
        }

        const result = await Swal.fire({
            title: 'Marcar como Enviado?',
            text: 'Deseja avan\u00e7ar este item para "Enviado"?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, enviar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        try {
            await ClientQuoteDetailsApi.updateQuotationStatus(id, 'enviado');
            Swal.fire('Sucesso', 'Status atualizado para "Enviado".', 'success').then(() => {
                this.initDetalhes();
            });
        } catch (err) {
            console.error('Erro ao atualizar status para enviado:', err);
            Swal.fire('Erro', 'N\u00e3o foi poss\u00edvel atualizar o status.', 'error');
        }
    };

    handleFinalizarFluxo = async () => {
        const id = this.getQuotationIdFromUrl();
        if (!id) {
            Swal.fire('Erro', 'ID da estimativa n\u00e3o encontrado.', 'error');
            return;
        }

        const result = await Swal.fire({
            title: 'Finalizar Opera\u00e7\u00e3o?',
            text: 'Deseja finalizar o fluxo desta cota\u00e7\u00e3o?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, finalizar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        try {
            await ClientQuoteDetailsApi.updateQuotationStatus(id, 'finalizado');
            Swal.fire('Sucesso', 'Fluxo finalizado com sucesso.', 'success').then(() => {
                this.initDetalhes();
            });
        } catch (err) {
            console.error('Erro ao finalizar fluxo:', err);
            Swal.fire('Erro', 'N\u00e3o foi poss\u00edvel finalizar o fluxo.', 'error');
        }
    };

    carregarOrcamento = async (userId, empresa, orcamentoId, estimativaId) => {
        try {
            const result = await WorkshopService.loadBudget(userId, empresa, orcamentoId, estimativaId);
            window.location.hash = result.redirect_url;
        } catch (error) {
            console.error('Erro ao carregar orcamento:', error);
            Swal.fire('Erro', 'N\u00e3o foi poss\u00edvel carregar o or\u00e7amento.', 'error');
        }
    };


    carregarOrcamento = (userId, empresa, orcamentoId, estimativaId) => {
        window.location.hash = `#orcamento?user_id=${userId}&empresa=${empresa}&orcamento_id=${orcamentoId}&estimativa_id=${estimativaId}`;
    };


    renderCliente = () => {
        const { cliente } = this.state;
        if (!cliente) return null;

        return (
            <Box className={this.props.classes.sectionBody}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                            <span className={this.props.classes.label}>Empresa:</span>
                            {cliente.empresa || '-'}
                        </Typography>
                        <Typography variant="body1">
                            <span className={this.props.classes.label}>Nome:</span>
                            {cliente.nome || '-'}
                        </Typography>
                        <Typography variant="body1">
                            <span className={this.props.classes.label}>Telefone:</span>
                            {cliente.telefone || '-'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} style={{ textAlign: 'right' }}>
                        <Typography variant="body1">
                            <span className={this.props.classes.label}>CNPJ:</span>
                            {cliente.cnpj || '-'}
                        </Typography>
                        <Typography variant="body1">
                            <span className={this.props.classes.label}>Data:</span>
                            {this.formatarData(cliente.dt_criacao)}
                        </Typography>
                        <Typography variant="body1">
                            <span className={this.props.classes.label}>E-mail:</span>
                            {cliente.email || '-'}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        );
    };

    renderEstimativa = () => {
        const { estimativa, rotasimplesempresa } = this.state;
        const { classes } = this.props;

        if (!estimativa) {
            return (
                <Typography variant="body2" color="textSecondary">
                    Nenhuma estimativa carregada.
                </Typography>
            );
        }

        let itens = estimativa.itens;
        if (typeof itens === "string") {
            try {
                itens = JSON.parse(itens);
            } catch (e) {
                itens = [];
            }
        }

        const renderActionButtons = () => {
            const status = estimativa.status?.toLowerCase();

            if (status === 'equipamento em analise' || status === 'equipamento em an\u00e1lise') {
                return (
                    <Box className={classes.actionButtons}>
                        <Button
                            variant="contained"
                            style={{ backgroundColor: '#28a745', color: 'white' }}
                            onClick={() => this.fazerApontamento(this.state.workshopId)}
                        >
                            2 - Fazer Apontamento
                        </Button>
                    </Box>
                );
            } else if (status === 'autorizar manutencao') {
                return (
                    <Box className={classes.actionButtons}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleApproveMaintenance}
                        >
                            {'Aprovar para Manuten\u00e7\u00e3o'}
                        </Button>
                    </Box>
                );
            } else if (status === 'pronto para retirada') {
                return (
                    <Box className={classes.actionButtons}>
                        <Button
                            variant="contained"
                            style={{ backgroundColor: '#28a745', color: 'white' }}
                            onClick={this.handleMarkAsSent}
                        >
                            Marcar como Enviado
                        </Button>
                    </Box>
                );
            } else if (status === 'aguardando equipamento') {
                return (
                    <Button
                        variant="contained"
                        className={classes.recebimentoButton}
                        onClick={() => this.receberEquipamento(this.state.workshopId)}
                        style={{ position: 'absolute', top: 10, right: 10 }}
                    >
                        1 - Receber Equipamento
                    </Button>
                );
            }

            return null;
        };

        return (
            <Box className={classes.sectionBody} position="relative">
                {renderActionButtons()}

                <Typography variant="body1">
                    <strong>{'N\u00ba Estimativa:'}</strong> {estimativa.id || '-'}
                </Typography>
                <Typography variant="body1">
                    <strong>Status:</strong> {estimativa.status}
                </Typography>
                <Typography variant="body1">
                    <strong>Local:</strong> {estimativa.endereco || '-'}
                </Typography>

                <Typography variant="body1" style={{ marginTop: 16 }}>
                    <strong>Itens:</strong>
                </Typography>

                <List className={classes.listGroup}>
                    {Array.isArray(itens) && itens.length > 0 ? (
                        itens.map((item, index) => (
                            <ListItem key={index} className={classes.listItem}>
                                <ListItemText
                                    primary={item.servico || '-'}
                                    secondary={item.obs ? <small>{item.obs}</small> : null}
                                />
                            </ListItem>
                        ))
                    ) : (
                        <ListItem className={classes.listItem}>
                            <ListItemText primary="Nenhum item" />
                        </ListItem>
                    )}
                </List>

                <Box className={classes.respostaBox}>
                    <Typography variant="body1">
                        <strong>Resposta:</strong> {estimativa.texto_resposta || '-'}
                    </Typography>
                    <Typography variant="body1">
                        <strong>Valor:</strong> {this.formatarMoeda(estimativa.valor_resposta)}
                    </Typography>
                </Box>

                {estimativa.motivo_recusa && (
                    <Box className={classes.recusaBox}>
                        <Typography variant="body1">
                            <strong>Motivo Recusa:</strong>
                        </Typography>
                        <Typography variant="body2">{estimativa.motivo_recusa}</Typography>
                    </Box>
                )}
            </Box>
        );
    };

    renderOrcamento = () => {
        const { orcamento } = this.state;
        const { classes } = this.props;

        let orcamentoContent = [];

        if (orcamento.itens?.length) {
            const agrupados = WorkshopService.groupBudgetItemsByEquipment(orcamento.itens);

            Object.entries(agrupados).forEach(([equipId, itens]) => {
                const eq = itens[0];
                const cabecalhoEquip = `${eq.equipamento_nome || "Equipamento"} - ${eq.equipamento_marca || "-"} - ${eq.equipamento_modelo || "-"} - ${eq.equipamento_serie || "-"}`;

                const totals = WorkshopService.calculateBudgetTotals(itens);

                const pecasHtml = itens
                    .filter(item => item.tipo_item === "peca")
                    .map((item, index) => {
                        const total = (Number(item.qtd) || 1) * (Number(item.valor) || 0);
                        return (
                            <Box key={`${item.equip_id}-peca-${index}`} display="flex"
                                justifyContent="space-between">
                                <Typography variant="body2">
                                    {item.codigo_interno || '-'} | {item.qtd}x {item.nome || '-'}
                                </Typography>
                                <Typography variant="body2" className={classes.valorMonetario}>
                                    {this.formatarMoeda(total)}
                                </Typography>
                            </Box>
                        );
                    });

                const procedimentosHtml = itens
                    .filter(item => item.tipo_item === "procedimento")
                    .map((item, index) => {
                        const total = (Number(item.qtd) || 1) * (Number(item.valor) || 0);
                        return (
                            <Box key={`${item.equip_id}-proc-${index}`} display="flex"
                                justifyContent="space-between">
                                <Typography variant="body2">
                                    {item.codigo_interno || '-'} | {item.qtd}x {item.nome || '-'}
                                </Typography>
                                <Typography variant="body2" className={classes.valorMonetario}>
                                    {this.formatarMoeda(total)}
                                </Typography>
                            </Box>
                        );
                    });

                orcamentoContent.push(
                    <Paper key={equipId} className={classes.equipamentoCard} elevation={1}>
                        <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                            {cabecalhoEquip.toUpperCase()}
                        </Typography>

                        <Paper className={classes.itemGroup} elevation={0}>
                            <Typography variant="body2" style={{ fontStyle: 'italic' }}>
                                {'Pe\u00e7as:'}
                            </Typography>
                            {pecasHtml.length > 0 ? pecasHtml :
                                <Typography variant="body2"><small>{'Nenhuma pe\u00e7a'}</small></Typography>}
                            <Box display="flex" justifyContent="flex-end" mt={1}>
                                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                    {'Total pe\u00e7as:'} <span
                                        className={classes.valorMonetario}>{this.formatarMoeda(totals.totalPecas)}</span>
                                </Typography>
                            </Box>
                        </Paper>

                        <Paper className={classes.itemGroup} elevation={0}>
                            <Typography variant="body2" style={{ fontStyle: 'italic' }}>
                                Procedimentos:
                            </Typography>
                            {procedimentosHtml.length > 0 ? procedimentosHtml :
                                <Typography variant="body2"><small>Nenhum procedimento</small></Typography>}
                            <Box display="flex" justifyContent="flex-end" mt={1}>
                                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                    Total procedimentos: <span
                                        className={classes.valorMonetario}>{this.formatarMoeda(totals.totalProcedimentos)}</span>
                                </Typography>
                            </Box>
                        </Paper>

                        <Box display="flex" justifyContent="flex-end" mt={1}>
                            <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                TOTAL EQUIPAMENTO: <span
                                    className={classes.valorMonetario}>{this.formatarMoeda(totals.totalGeral)}</span>
                            </Typography>
                        </Box>
                    </Paper>
                );
            });
        }

        return (
            <Box className={classes.sectionBody}>
                <Typography variant="body1">
                    <strong>Status:</strong> {orcamento.status}
                </Typography>
                <Typography variant="body1">
                    <strong>{'Valor total do or\u00e7amento:'}</strong>{' '}
                    <span className={classes.valorMonetario}>{this.formatarMoeda(orcamento.valor || 0)}</span>
                </Typography>
                <Typography variant="body1">
                    <strong>{'Observa\u00e7\u00f5es:'}</strong> {orcamento.observacoes || '-'}
                </Typography>

                {orcamentoContent}
            </Box>
        );
    }


    renderLoading = () => (
        <Box className={this.props.classes.loadingContainer}>
            <Typography variant="h6">Carregando detalhes do workshop...</Typography>
        </Box>
    );

    renderError = () => (
        <Box className={this.props.classes.errorContainer}>
            <Typography variant="h6" color="error">
                {this.state.error}
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={this.initDetalhes}
                style={{ marginTop: 16 }}
            >
                Tentar Novamente
            </Button>
        </Box>
    );

    renderContent = () => {
        const { sections, cliente, estimativa, orcamento, serviceFiles, rotasimplesempresa, workshopId } = this.state;
        const { classes, currentLanguage } = this.props;

        return (
            <Box className={classes.root}>
                <CardSection
                    title={'DADOS DO CLIENTE'}
                    expanded={sections.cliente}
                    onToggle={() => this.toggleSection('cliente')}
                >
                    <ClienteSection cliente={cliente} currentLanguage={currentLanguage} />
                </CardSection>

                <CardSection
                    title={'DADOS DA ESTIMATIVA'}
                    expanded={sections.estimativa}
                    onToggle={() => this.toggleSection('estimativa')}
                >
                    <EstimativaSection
                        estimativa={estimativa}
                        rotasimplesempresa={rotasimplesempresa}
                        onReceberEquipamento={this.receberEquipamento}
                        onFazerApontamento={this.fazerApontamento}
                        onApproveMaintenance={this.handleApproveMaintenance}
                        onMarkAsSent={this.handleMarkAsSent}
                        onFinalizarFluxo={this.handleFinalizarFluxo}
                        modo="workshop"
                    />
                </CardSection>

                <CardSection
                    title={'DADOS DO OR\u00c7AMENTO'}
                    expanded={sections.orcamento}
                    onToggle={() => this.toggleSection('orcamento')}
                >
                    <OrcamentoSection
                        orcamento={orcamento}
                        modo="workshop"
                    />
                    <QuoteBudgetFileSection
                        quoteId={this.state.workshopId}
                        role="workshop"
                        currentLanguage={currentLanguage}
                        serviceFiles={serviceFiles}
                        status={estimativa?.status}
                    />

                    <QuoteLaudoFileSection
                        quoteId={workshopId}
                        role="workshop"
                        currentLanguage={currentLanguage}
                        serviceFiles={serviceFiles}
                        status={estimativa?.status}
                    />
                    <QuoteNfFileSection
                        quoteId={workshopId}
                        role="workshop"
                        currentLanguage={currentLanguage}
                        serviceFiles={serviceFiles}
                    />

                </CardSection>

                {(estimativa?.status === 'aprovado para manuten\u00e7\u00e3o' || estimativa?.status === 'aprovado para manutencao') && (
                    <CardSection
                        title={'MANUTEN\u00c7\u00c3O E LAUDO'}
                        expanded={sections.manutencao}
                        onToggle={() => this.toggleSection('manutencao')}
                    >
                        <Box p={2}>
                            <Typography variant="body1" gutterBottom>
                                {'A manuten\u00e7\u00e3o deste equipamento foi autorizada pelo cliente. Ap\u00f3s realizar os servi\u00e7os, clique no bot\u00e3o abaixo para prosseguir com a inspe\u00e7\u00e3o e emiss\u00e3o do laudo t\u00e9cnico.'}
                            </Typography>
                            <Box mt={2}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleCompleteMaintenance}
                                    style={{ backgroundColor: '#00C2E0', color: '#FFFFFF', fontWeight: 'bold' }}
                                >
                                    {'Manuten\u00e7\u00e3o Realizada'}
                                </Button>
                            </Box>
                        </Box>
                    </CardSection>
                )}

                <ServiceFilesSection
                    serviceFiles={serviceFiles}
                    currentLanguage={currentLanguage}
                    quoteId={workshopId}
                    role="workshop"
                />
                <NotasFileSection
                    serviceFiles={serviceFiles}
                    currentLanguage={currentLanguage}
                    quoteId={workshopId}
                    role="workshop"
                />
            </Box>
        );
    };


    render() {
        const { loading, error } = this.state;
        const { currentLanguage } = this.props;
        const breadcrumbItems = [
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_home, path: '/bepi/workshop' },
            // { label: currentLanguage.bepiService.workshop.workshop_breadcrumb_quotations, path: '/bepi/workshop/quotations' },
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_details },
        ];

        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.shared.shared_breadcrumb_details}
                breadcrumbItems={breadcrumbItems}
                currentLanguage={currentLanguage}
                showBackButton
            >
                {loading ? this.renderLoading() :
                    error ? this.renderError() :
                        this.renderContent()}
            </BreadcrumbLayout>
        );
    }
}

export default withStyles(styles)(WorkshopDetailsPage);
